import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import { OrganizationType} from '../models/peripherals/organization-type';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';


@Injectable()
export class CommonService {

  public token: string;
  currentUser:any;

  constructor(private http: Http) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
   }

   createAuthorizationHeader(headers:Headers) {
      this.currentUser = localStorage.getItem('currentUser');
      if (this.currentUser && this.currentUser > 0)
      {
          this.currentUser  = JSON.parse(this.currentUser);//console.log(this.currentUser);
          this.token = this.currentUser.token;
      }
      else{
          this.currentUser = sessionStorage.getItem('currentUser');
          this.currentUser  = JSON.parse(this.currentUser);//console.log(this.currentUser);
          this.token = this.currentUser.token;
      }
    //
    //  headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Authorization', 'Bearer ' + this.token);
  }
  //Call to  get applicant types service 
  getApplicantType(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}applicant_type`,{headers: headers})

        .map((response: Response) => {
            //
            return response.json();
        });
  }
  // Call to doing business type service service
  getDBAType(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}dba_type`,{headers: headers})

        .map((response: Response) => {
           //
            return response.json();
        });
  }
  // Call to address type service
  getAddressType(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}address_type`,{headers: headers})

        .map((response: Response) => {
          //
            return response.json();
        });
  }

  // Call to organization type service
  getOrgType(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}organization_type`,{headers: headers})

        .map((response: Response) => {
         //
            return response.json();
        });
  }
  // Call to phone type service
  getPhoneType(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}phone_type`,{headers: headers})

        .map((response: Response) => {
         //
            return response.json();
        });
  }

  // Call to record managers/users service
  getRecordManager(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}user/1`,{headers: headers})
        .map((response: Response) => {
         //
            return response.json();
        });
  }

  // Call to relation type service
  getRelationTypes(): Observable<any>
  {
    var headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(`${environment.api}relation_type`,{headers: headers})

        .map((response: Response) => {
         //
            return response.json();
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts